const REFERRER_CODE = 'referrer-code';

type ReferrerCodeType = { referrerCode: string; timestamp: number };

const MONTH_IN_MILLISECONDS = 2629800000;

const setReferrerCode = (referrerCode: string) => {
  const value: ReferrerCodeType = { referrerCode, timestamp: new Date().getTime() };
  localStorage.setItem(REFERRER_CODE, JSON.stringify(value));
};

const getReferrerCode = (): string | null => {
  const value = localStorage.getItem(REFERRER_CODE);
  if (!value) return null;

  const { referrerCode, timestamp } = JSON.parse(value) as ReferrerCodeType;
  if (new Date().getTime() - timestamp > MONTH_IN_MILLISECONDS) return null;

  return referrerCode;
};

const removeReferrerCode = () => {
  localStorage.removeItem(REFERRER_CODE);
};

export const referrerCodeStorage = {
  setReferrerCode,
  getReferrerCode,
  removeReferrerCode,
};
